import { Injectable } from '@angular/core';
import { BaseFileClientProviderService } from 'app/model/services/base-file-client-provider.service';
import { IFileClient } from 'app/services/interfaces/IFileClient';
import { LocalFileClientService } from './local-file-client.service';

@Injectable()
export class FileClientProviderService extends BaseFileClientProviderService<IFileClient> {
    protected readonly className = 'FileClientProviderService';

    protected getClient(): IFileClient {
        return this._injector.get<LocalFileClientService>(LocalFileClientService);
    }
}
